/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RoutesStatsDetailDtoModel, RoutesStatsDetailDtoModelType } from "./RoutesStatsDetailDtoModel"
import { RoutesStatsDetailDtoModelSelector } from "./RoutesStatsDetailDtoModel.base"
import { RootStoreType } from "./index"


/**
 * RoutesStatsDtoBase
 * auto generated base class for the model RoutesStatsDtoModel.
 *
 * Aggregate Routes Utilization
 */
export const RoutesStatsDtoModelBase = ModelBase
  .named('RoutesStatsDto')
  .props({
    __typename: types.optional(types.literal("RoutesStatsDto"), "RoutesStatsDto"),
    /** Comprised of {PROJECT_ID}-{START_DATE} */
    id: types.identifier,
    /** The project ID for the summary */
    projectId: types.union(types.undefined, types.integer),
    /** The start date for the summary */
    startDate: types.union(types.undefined, types.string),
    hasUnpublished: types.union(types.undefined, types.boolean),
    active: types.union(types.undefined, types.late((): any => RoutesStatsDetailDtoModel)),
    published: types.union(types.undefined, types.late((): any => RoutesStatsDetailDtoModel)),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class RoutesStatsDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get projectId() { return this.__attr(`projectId`) }
  get startDate() { return this.__attr(`startDate`) }
  get hasUnpublished() { return this.__attr(`hasUnpublished`) }
  active(builder: string | RoutesStatsDetailDtoModelSelector | ((selector: RoutesStatsDetailDtoModelSelector) => RoutesStatsDetailDtoModelSelector) | undefined) { return this.__child(`active`, RoutesStatsDetailDtoModelSelector, builder) }
  published(builder: string | RoutesStatsDetailDtoModelSelector | ((selector: RoutesStatsDetailDtoModelSelector) => RoutesStatsDetailDtoModelSelector) | undefined) { return this.__child(`published`, RoutesStatsDetailDtoModelSelector, builder) }
}
export function selectFromRoutesStatsDto() {
  return new RoutesStatsDtoModelSelector()
}

export const routesStatsDtoModelPrimitives = selectFromRoutesStatsDto().projectId.startDate.hasUnpublished
